import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { categories } from '../../func/skills.js'
import Skills from './skills.js'

import { addTagsSearch } from '../../func/skills.js'

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

const Content = styled.div`
  padding: 25px 0 15px 30px;
  border-radius: 20px;
  transition: background-color 0.5s ease;
  margin-left: 15px;
`

const Header = styled.div`
  display: flex;
`

const Body = styled.div`
  margin: 10px 0 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > input {
    width: 80%;
  }
  & > label {
    margin: 7px 0;
  }
`

const HeaderInfo = styled.div`
  max-width: 70%;
  padding: 5px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const ProfilePicture = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background-color: rgb(233, 233, 233);
  margin: 0 10px;
  object-fit: cover;
  background: url('/assets/svg/user.svg');
  background-size: cover;
`

const ModifyIcon = styled.div`
  width: 70px;
  height: 70px;
  background: url('/assets/svg/modif.svg');
  position: absolute;
  top: 5px;
  right: 5px;
`

const Name = styled.input`
  font-size: 17px;
  color: rgb(61, 60, 60);
  font-weight: bold;
  padding: 8px 0 8px 8px;
  border-radius: 5px;
  background: rgb(232, 232, 232);
  border: none;
`

const Text = styled.input`
  font-size: 13px;
  color: rgb(108, 108, 108);
  margin: 5px 0;
  padding: 8px 0 8px 8px;
  border-radius: 5px;
  background: rgb(232, 232, 232);
  border: none;
`

const IconWrapper = styled.div`
  height: 70px;
  width: 170px;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
  display: flex;
  justify-content: space-around;
`

const ValidIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/valid.svg');
`

const CloseIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/close.svg');
`
const RemoveIcon = styled.div`
  width: 50px;
  height: 50px;
  background: url('/assets/svg/remove.svg');
`

const InputPPFile = styled.input`
  display: none;
`

const RadioWrapper = styled.div`
  width: 80%;
  background: rgb(232, 232, 232);
  padding:  8px 0 8px 8px;
  border-radius: 5px;
  border: none;
  & > div > input {
    display: none;
  }
  & > div {
    margin: 15px 0;
    display: relative;
  }
  & > div > label{
    position : relative;
  	left: 10px;
  	padding-left: 35px;
  	margin-left : 0px;
  }
  & > div > label:before{
    content : '';
    display : block;
    position : absolute;
    width : 15px;
    height : 15px;
    border-radius : 5px;
    border : 1px solid #a6a6a6;
    top : 0;
    bottom: 0;
    margin: auto 0;

  }
  & > div > label:after{
    content : '';
    display : none;
    position : absolute;
    width : 7px;
    height : 7px;
    left: 4px;
    border : 1px solid #a6a6a6;
    border-radius : 3px;
    top : 0;
    bottom: 0;
    margin: auto 0;
    background: #a6a6a6;
 }
  }
  & > div > input[type="radio"]:checked + .labelRadio:after{
    display: block;
  }
`

class AdminCard extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      firstname: this.props.item.firstname || '',
      lastname: this.props.item.lastname || '',
      member: this.props.item.member || '',
      company: this.props.item.company || '',
      job: this.props.item.job || '',
      adress: this.props.item.adress || '',
      cp: this.props.item.cp || '',
      phone1: this.props.item.phone1 || '',
      phone2: this.props.item.phone2 || '',
      mobilephone: this.props.item.mobilephone || '',
      email: this.props.item.email || '',
      website1: this.props.item.website1 || '',
      website2: this.props.item.website2 || '',
      skills: this.props.item.skills || '',
      id: this.props.item.id || '',
      profilpic: this.props.item.profilpic || '',
      tags: this.props.item.tags || '',
      twitter: this.props.item.twitter || '',
    }
  }

  setNewPP = () => {
    this.setState({
      profilpic: document.getElementById('inputPP').files[0],
    })
  }

  handleInputChange = (key, event) => {
    let obj = {}
    obj[key] = event.target.value
    this.setState(obj)
  }

  triggerInputFile = () => {
    document.getElementById('inputPP').click()
  }

  handleSkillsChange = (string) => {
    this.setState({
      skills: string,
    })
  }

  render() {
    let {
      firstname,
      lastname,
      member,
      company,
      job,
      adress,
      cp,
      phone1,
      phone2,
      mobilephone,
      email,
      website1,
      website2,
      skills,
      id,
      profilpic,
      twitter,
      tags,
    } = this.state
    return (
      <Wrapper>
        <IconWrapper>
          <ValidIcon
            onClick={() => this.props.validButton(addTagsSearch(this.state))}
          />
          <CloseIcon onClick={() => this.props.toggleAdminCard()} />
          {this.props.context === 'addMember' ? (
            ''
          ) : (
            <RemoveIcon onClick={() => this.props.deleteMember()} />
          )}
        </IconWrapper>
        <Content onClick={() => console.log(addTagsSearch(this.state))}>
          {/* <Header> */}
          <Body>
            <InputPPFile type="file" id="inputPP" onChange={this.setNewPP} />
            <ProfilePicture
              id={this.state.id}
              src={
                typeof profilpic === 'object'
                  ? URL.createObjectURL(profilpic)
                  : profilpic
              }
              alt="profile_pic"
              onClick={this.triggerInputFile}
            />
            {/* <HeaderInfo> */}
            <label>Nom: </label>
            <Name
              type="text"
              name="lastname"
              onChange={(e) => this.handleInputChange('lastname', e)}
              defaultValue={lastname}
            />
            <label>Prenom: </label>
            <Name
              type="text"
              name="firstname"
              defaultValue={firstname}
              onChange={(e) => this.handleInputChange('firstname', e)}
            />
            <label>Membre: </label>
            {/* <fieldset> */}
            <RadioWrapper>
              {/* <form
                action=""
                style={{ display: 'flex', flexDirection: 'column' }}
              > */}
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputAssocié"
                  value="Associé"
                  checked={member.toLowerCase() === 'Associé'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputAssocié">
                  Associé
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputAdhérent"
                  value="Adhérent"
                  checked={member.toLowerCase() === 'Adhérent'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputAdhérent">
                  Adhérent
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputActif"
                  value="Actif"
                  checked={member.toLowerCase() === 'Actif'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputActif">
                  Actif
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputDeDroit"
                  value="de droit"
                  checked={member.toLowerCase() === 'de droit'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputDeDroit">
                  de droit
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputHonoraire"
                  value="Honoraire"
                  checked={member.toLowerCase() === 'Honoraire'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputHonoraire">
                  Honoraire
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="membre"
                  id="inputÉtudiant"
                  value="Étudiant"
                  checked={member.toLowerCase() === 'Étudiant'.toLowerCase()}
                  onChange={(e) => this.handleInputChange('member', e)}
                />
                <label className="labelRadio" htmlFor="inputÉtudiant">
                  Étudiant
                </label>
              </div>

              {/* </form> */}
              {/* </fieldset> */}
            </RadioWrapper>
            <label>Job: </label>
            <Text
              type="text"
              name="job"
              defaultValue={job}
              onChange={(e) => this.handleInputChange('job', e)}
            />
            <label>Entreprise: </label>
            <Text
              type="text"
              name="company"
              defaultValue={company}
              onChange={(e) => this.handleInputChange('company', e)}
            />
            {/* </HeaderInfo> */}
            {/* </Header> */}
            {/* <Body> */}
            <label>Adresse: </label>
            <Text
              type="text"
              name="adress"
              defaultValue={adress}
              onChange={(e) => this.handleInputChange('adress', e)}
            />
            <label>Code Postal: </label>
            <Text
              type="text"
              name="cp"
              defaultValue={cp}
              onChange={(e) => this.handleInputChange('cp', e)}
            />
            <label>Telephone: </label>
            <Text
              type="text"
              name="phone1"
              defaultValue={phone1}
              onChange={(e) => this.handleInputChange('phone1', e)}
            />
            <label>Telephone Mobile: </label>
            <Text
              type="text"
              name="mobilephone"
              defaultValue={mobilephone}
              onChange={(e) => this.handleInputChange('mobilephone', e)}
            />
            <label>Site Web 1: </label>
            <Text
              type="text"
              name="website1"
              defaultValue={website1}
              onChange={(e) => this.handleInputChange('website1', e)}
            />
            <label>Site Web 2: </label>
            <Text
              type="text"
              name="website2"
              defaultValue={website2}
              onChange={(e) => this.handleInputChange('website2', e)}
            />
            <label>Email: </label>
            <Text
              type="text"
              name="email"
              defaultValue={email}
              onChange={(e) => this.handleInputChange('email', e)}
            />
            <label>Twitter: </label>
            <Text
              type="text"
              name="twitter"
              defaultValue={twitter}
              onChange={(e) => this.handleInputChange('twitter', e)}
            />
            <Skills
              newCat={this.props.newCat}
              skills={skills}
              handleSkillsChange={(string) => this.handleSkillsChange(string)}
            />
          </Body>
        </Content>
      </Wrapper>
    )
  }
}

export default AdminCard



// WEBPACK FOOTER //
// ./src/components/admin/index.js